import React from 'react';
import { Tag } from 'antd';
import { CargoContractStatusTypes } from '@shared/utils/constants';
import { Values } from '@shared/utils/objectEnums';
import styles from './styles/CargoContractStatusTag.module.css';

type Props = {
	status: Values<typeof CargoContractStatusTypes>;
	label?: string;
};

const contractStatusConfig: Record<
	Values<typeof CargoContractStatusTypes>,
	{
		label: string;
		color: string;
	}
> = {
	[CargoContractStatusTypes.Pending]: {
		label: 'Pending',
		color: 'blue',
	},
	[CargoContractStatusTypes.TentativeBooking]: {
		label: 'Tentative booking',
		color: 'gold',
	},
	[CargoContractStatusTypes.Contracted]: {
		label: 'Contracted',
		color: 'purple',
	},
	[CargoContractStatusTypes.OnVoyage]: {
		label: 'On voyage',
		color: 'green',
	},
	[CargoContractStatusTypes.Cancelled]: {
		label: 'Cancelled',
		color: 'red',
	},
};

const CargoContractStatusTag = ({
	status,
	label,
}: Props) => {
	if (status == null) {
		return (
			<Tag className={styles.tag}>
				N/A
			</Tag>
		);
	}

	const config = contractStatusConfig[status];

	if (config == null) {
		return (
			<Tag className={styles.tag}>
				{label ?? status}
			</Tag>
		);
	}

	return (
		<Tag
			color={config.color}
			className={styles.tag}
		>
			{label ?? config.label}
		</Tag>
	);
};

export default CargoContractStatusTag;